// src/firebase/firebaseInit.js
import { initializeApp } from 'firebase/app';
import {
    initializeAuth,
    browserLocalPersistence,
    browserPopupRedirectResolver,
    onAuthStateChanged,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// New Firebase project configuration
const newFirebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Old Firebase project configuration
const oldFirebaseConfig = {
    apiKey: import.meta.env.VITE_OLD_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_OLD_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_OLD_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_OLD_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_OLD_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_OLD_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_OLD_FIREBASE_MEASUREMENT_ID
};

// Initialize both Firebase apps
const newFirebaseApp = initializeApp(newFirebaseConfig, 'newFirebaseApp');
const oldFirebaseApp = initializeApp(oldFirebaseConfig, 'oldFirebaseApp');

// App Check — required by firebase-web-authn extension.
// Set VUE_APP_RECAPTCHA_V3_SITE_KEY in .env (reCAPTCHA v3 site key from Firebase console).
if (import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY) {
    initializeAppCheck(newFirebaseApp, {
        provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY),
        isTokenAutoRefreshEnabled: true,
    });
}

// Get auth and Firestore instances for both apps.
// Auth starts on localStorage: getAuth() + setPersistence() left the cross-tab listener on IndexedDB.
const authOptions = {
    persistence: browserLocalPersistence,
    popupRedirectResolver: browserPopupRedirectResolver,
};
const newAuth = initializeAuth(newFirebaseApp, authOptions);
const oldAuth = initializeAuth(oldFirebaseApp, authOptions);
const newDb = getFirestore(newFirebaseApp);
const oldDb = getFirestore(oldFirebaseApp);

// Set up token refresh mechanism
let tokenRefreshInterval = null;

// Function to refresh the token periodically
// const startTokenRefresh = (auth) => {
//     if (tokenRefreshInterval) {
//         clearInterval(tokenRefreshInterval);
//     }
    
//     // Refresh token every 50 minutes (3000000 ms)
//     // This is less than the 1 hour expiration to ensure we refresh before expiration
//     tokenRefreshInterval = setInterval(() => {
//         const user = auth.currentUser;
//         if (user) {
//             user.getIdToken(true)
//                 .catch(error => {
//                     console.error("Error refreshing token:", error);
//                 });
//         }
//     }, 3000000);
// };

// Listen for auth state changes to start/stop token refresh
// TODO: check if it's still needed after apiClient interceptors setup
// onAuthStateChanged(newAuth, (user) => {
//     if (user) {
//         startTokenRefresh(newAuth);
//     } else if (tokenRefreshInterval) {
//         clearInterval(tokenRefreshInterval);
//     }
// });

// Export both sets of instances
export { newAuth, oldAuth, newDb, oldDb, newFirebaseApp, oldFirebaseApp };

// For backward compatibility, export default instances
export const auth = newAuth;
export const db = newDb;

// Export a function to check and refresh token on demand
// export const refreshAuthToken = async () => {
//     const user = newAuth.currentUser;
//     if (user) {
//         try {
//             await user.getIdToken(true);
//             return true;
//         } catch (error) {
//             console.error("Error refreshing token on demand:", error);
//             return false;
//         }
//     }
//     return false;
// };